const ChevronLeftIcon = ({ color = '#4079F5', width = 6, height = 10 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 6 10"
    fill="none"
  >
    <path
      d="M2.27027 5L6 1.16667L4.86486 0L0 5L4.86486 10L6 8.83333L2.27027 5Z"
      fill={color}
    />
  </svg>
)

export default ChevronLeftIcon
